import { api } from "@/http/api-client"
import type {
  TAddTransactionRequest,
  TAddTransferRequest,
  TGetAccountsSummaryResponse,
  TListPendingTransactionsResponse,
  TListTransactionsResponse,
  TUpdateTransactionRequest,
} from "./transaction-types"

export function addTransaction(params: TAddTransactionRequest) {
  return api.post("/finances/transactions", {
    json: params,
  })
}

export function listTransactions(
  organizationSlug: string,
  month: number,
  year: number,
) {
  const searchParams = new URLSearchParams()
  searchParams.set("organizationSlug", organizationSlug)

  return api.get<TListTransactionsResponse>(
    `/finances/transactions/${month}/${year}?${searchParams.toString()}`,
  )
}

export function listTransactionsByPerson(
  organizationSlug: string,
  personId: string,
) {
  const searchParams = new URLSearchParams()
  searchParams.set("organizationSlug", organizationSlug)

  return api.get<TListTransactionsResponse>(
    `/finances/transactions/person/${personId}?${searchParams.toString()}`,
  )
}

export function listPendingTransactions(organizationSlug: string) {
  const searchParams = new URLSearchParams()
  searchParams.set("organizationSlug", organizationSlug)

  return api.get<TListPendingTransactionsResponse>(
    `/finances/transactions/pending?${searchParams.toString()}`,
  )
}

export function updateTransactionStatus(
  id: string,
  organizationSlug: string,
  isPaid: boolean,
) {
  return api.patch(`/finances/transactions/${id}/status`, {
    json: { organizationSlug, isPaid },
  })
}

export function updateTransaction(
  id: string,
  params: TUpdateTransactionRequest,
) {
  return api.patch(`/finances/transactions/${id}`, {
    json: params,
  })
}

export function deleteTransaction(
  id: string,
  organizationSlug: string,
  recurrenceUpdate: "current" | "next" | "all" | null = null,
) {
  return api.delete(`/finances/transactions/${id}`, {
    json: { organizationSlug, recurrenceUpdate },
  })
}

export function addTransfer(params: TAddTransferRequest) {
  return api.post("/finances/transactions/transfer", {
    json: params,
  })
}

export function getAccountsSummary(
  organizationSlug: string,
  month: number,
  year: number,
) {
  const searchParams = new URLSearchParams()
  searchParams.set("organizationSlug", organizationSlug)

  return api.get<TGetAccountsSummaryResponse>(
    `/finances/accounts/summary/${month}/${year}?${searchParams.toString()}`,
  )
}
